
  export const testLogin = {
    email: "test@gmail.com",
    password: "Test123@",
  };